// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cir {
  border: 1px solid var(--color-primary);
  width: 35px;
  border-radius: 50%;
  height: 35px;
  display: inline-block;
  margin-right: 5px;
}

.card {
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  color: var(--color-card-text);
  border: none;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.container {
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
}
.container .title {
  font-weight: 600;
  margin-top: 1%;
  font-size: large;
}

.invalid {
  border-color: #d0021b;
}

.countryComponent {
  margin-top: 5%;
  padding-left: 0px;
  position: relative;
  width: 100%;
  min-height: 1px;
}
.countryComponent .selectionBox {
  margin-top: 3%;
}
.countryComponent .selectionBox .label {
  display: inline-block;
  position: absolute;
  font-size: 12px;
  left: 14px;
  font-weight: 600;
  color: var(--color-card-text);
}
.countryComponent .selectionBox .custom-select {
  height: 45px;
  font-size: 15px;
  padding-left: 14px;
  border-radius: 2px;
  padding-top: 15px;
}
.countryComponent .selectionBox .invalid {
  height: 45px;
  font-size: 15px;
  padding-left: 14px;
  border-radius: 2px;
  border-color: #d0021b;
  width: 100%;
  background-color: white;
}

.input-style {
  background-color: var(--color-card-background) !important;
  color: var(--color-card-text) !important;
}

input:-webkit-autofill,
input:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:focus {
  -webkit-transition: background-color 0s 600000s, color 0s 600000s !important;
  transition: background-color 0s 600000s, color 0s 600000s !important;
}

input {
  width: 100%;
  height: 45px;
  border: 1px solid lightgrey;
  border-radius: 2px;
  padding-left: 10px;
  margin-top: 3%;
  margin-left: 0px;
}

.saveaddr {
  margin-left: 10%;
  margin-right: 10%;
}

.save {
  font-size: medium;
  margin-top: 3%;
  font-weight: 600;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  color: var(--color-interaction-text);
}

.cancel {
  float: right;
  font-size: medium;
  margin-top: 3%;
  font-weight: 600;
  background-color: var(--color-card-background);
  border: none;
  color: var(--color-card-text);
}

.addr {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/delivery-options/update-address/update-address.component.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AACF;;AACA;EACE,2CAAA;AAEF;;AAAA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAGF;AAFE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AAIJ;;AAAA;EACE,qBAAA;AAGF;;AADA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAIF;AAFE;EACE,cAAA;AAIJ;AAHI;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AAKN;AADI;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAGN;AADI;EACE,YAAA;EAEA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;AAEN;;AAGA;EACE,yDAAA;EACA,wCAAA;AAAF;;AAGA;;;;EAIE,4EAAA;EAAA,oEAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAEA;EACE,gBAAA;EACA,iBAAA;AACF;;AACA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;EACA,YAAA;EACA,oCAAA;AAEF;;AAAA;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,8CAAA;EACA,YAAA;EACA,6BAAA;AAGF;;AADA;EACE,kBAAA;AAIF","sourcesContent":[".cir {\n  border: 1px solid var(--color-primary);\n  width: 35px;\n  border-radius: 50%;\n  height: 35px;\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.card {\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  color: var(--color-card-text);\n  border: none;\n}\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n.container {\n  padding-right: 0px;\n  padding-left: 0px;\n  margin-right: auto;\n  margin-left: auto;\n  .title {\n    font-weight: 600;\n    margin-top: 1%;\n    font-size: large;\n  }\n}\n\n.invalid {\n  border-color: #d0021b;\n}\n.countryComponent {\n  margin-top: 5%;\n  padding-left: 0px;\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  // padding-right: 15px;\n  .selectionBox {\n    margin-top: 3%;\n    .label {\n      display: inline-block;\n      position: absolute;\n      font-size: 12px;\n      left: 14px;\n      font-weight: 600;\n      color: var(--color-card-text);\n      // top: -1px;\n    }\n\n    .custom-select {\n      height: 45px;\n      font-size: 15px;\n      padding-left: 14px;\n      border-radius: 2px;\n      padding-top: 15px;\n    }\n    .invalid {\n      height: 45px;\n      // padding-top: 17px;\n      font-size: 15px;\n      padding-left: 14px;\n      border-radius: 2px;\n      border-color: #d0021b;\n      width: 100%;\n      background-color: white;\n    }\n  }\n}\n\n.input-style {\n  background-color: var(--color-card-background) !important;\n  color: var(--color-card-text) !important;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:focus {\n  transition: background-color 0s 600000s, color 0s 600000s !important;\n}\n\ninput {\n  width: 100%;\n  height: 45px;\n  border: 1px solid lightgrey;\n  border-radius: 2px;\n  padding-left: 10px;\n  margin-top: 3%;\n  margin-left: 0px;\n}\n.saveaddr {\n  margin-left: 10%;\n  margin-right: 10%;\n}\n.save {\n  font-size: medium;\n  margin-top: 3%;\n  font-weight: 600;\n  background-color: rgba(0, 0, 0, 0);\n  border: none;\n  color: var(--color-interaction-text);\n}\n.cancel {\n  float: right;\n  font-size: medium;\n  margin-top: 3%;\n  font-weight: 600;\n  background-color: var(--color-card-background);\n  border: none;\n  color: var(--color-card-text);\n}\n.addr {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
